import { authenticate } from '../api/auth';
import { getAuthToken } from '../queries/ats/auth/api';

let promises: Promise<unknown> | undefined = undefined;
let retryCount = 0;

async function createAuthPromises() {
  await authenticate();
  await getAuthToken();
  retryCount++;
}

export function createFetchProxy(fetchFn: typeof window.fetch) {
  return new Proxy(fetchFn, {
    apply: async function (target, that, args) {
      // args holds argument of fetch function
      // Do whatever you want with fetch request
      const result = Reflect.apply(target, that, args);

      if (!(result instanceof Promise)) {
        return result;
      }

      if (retryCount > 6) {
        return result;
      }

      await result.then(async (response) => {
        if (response.status === 204) {
          return response;
        }

        const clonesResponse = response.clone();
        const data = await clonesResponse.json();

        if (data.retcode === '-2') {
          if (promises) {
            await promises;
            promises = undefined;
            retryCount = 0;
          } else {
            promises = createAuthPromises();
          }
        }

        if (response.status === 401) {
          // If the request failed with a 401 status code, retry the request up to 3 times.
          if (promises) {
            await promises;
            promises = undefined;
            retryCount = 0;
          } else {
            promises = createAuthPromises();
          }
        }
      });

      return result;
    },
  });
}
